import React, { useEffect, useMemo, useState } from 'react'
import WarehouseDialog from './WarehouseDialog'
import { useCreateWarehouseMutation, useDeleteWarehouseMutation, useUpdateWarehouseMutation } from "src/_api/warehouseApi";

export default function WarehouseManagementDialog({
    openWarehouse,
    onClose,
    isEditing,
    warehouseId
}) {

    const [createWarehouse, { isLoading: createWarehouseLoading, isFetching: createWarehouseFetching ,  isSuccess: createWarehoueIsSuccess, error: createWarehoueError, reset: createWarehouseReset }] = useCreateWarehouseMutation()
    const [updateWarehouse, { isLoading: updateWarehouseLoading, isFetching: updateWarehouseFetching ,   isSuccess: updateWarehoueIsSuccess, error: updateWarehoueError, reset: updateWarehouseReset }] = useUpdateWarehouseMutation()
    const [deleteWarehouse, { isLoading: deleteWarehouseLoading, isFetching: deleteWarehouseFetching ,  isSuccess: deleteWarehoueIsSuccess, error: deleteWarehoueError, reset: deleteWarehouseReset }] = useDeleteWarehouseMutation()
      const isFetching =  createWarehouseFetching ||  updateWarehouseFetching ||  deleteWarehouseFetching
      const isLoading = createWarehouseLoading || updateWarehouseLoading || deleteWarehouseLoading 

    const createWarehouseHandler = async (payload) => {
        try {
            await createWarehouse(payload).unwrap()
            onActionDone()
        } catch (error) {
            console.log(error)
        }
    }
    const updateWarehouseHandler = async (payload) => {
        try {
            await updateWarehouse(payload).unwrap()
            onActionDone()
        } catch (error) {
            console.log(error)
        }
    }
    const deleteWarehouseHandler = async (id) => {
        try {
            await deleteWarehouse(id).unwrap()
            onActionDone()
        } catch (error) {
            console.log(error)
        }
    }

    const onActionDone = () => {
        setTimeout(() => {
            onClose()
        }, 900);
    }

    const resetWarehouseActions = () => {
        createWarehouseReset()
        updateWarehouseReset()
        deleteWarehouseReset()
    }

    const actionsError = useMemo(() => {
        if (!!createWarehoueError) return createWarehoueError
        if (!!updateWarehoueError) return updateWarehoueError
        if (!!deleteWarehoueError) return deleteWarehoueError
        return null
    }, [createWarehoueError, updateWarehoueError, deleteWarehoueError])

    const actionsIsSuccess = useMemo(() => {
        if (!!createWarehoueIsSuccess) return createWarehoueIsSuccess
        if (!!updateWarehoueIsSuccess) return updateWarehoueIsSuccess
        if (!!deleteWarehoueIsSuccess) return deleteWarehoueIsSuccess
        return null
    }, [createWarehoueIsSuccess, updateWarehoueIsSuccess, deleteWarehoueIsSuccess])


    useEffect(() => {
        if (!openWarehouse) {
            resetWarehouseActions()
        }
    }, [openWarehouse])

    return (
        <WarehouseDialog
            warehouseId={warehouseId}
            isEditing={isEditing}

            openWarehouse={openWarehouse}
            pending={ isLoading|| isFetching}
            onCreateWareHouse={createWarehouseHandler}
            onUpdateWareHouse={updateWarehouseHandler}
            onDeleteWareHouse={deleteWarehouseHandler}
            onClose={onClose}
            isSuccess={actionsIsSuccess}
            error={actionsError}
        />
    )
}